
import { Error } from '../../interface/upplm.common.interface';
import { ConfirmedPlacardInformation, clientKeys } from '../../interface/upplm.placardInformation';
export class DashboardResponse {
    placardId: string;
    isHung: boolean;
    placardStatus: string;
    cancelDate: string;
    companyName: string;
    urlTemporaryPlacard: string;
    phoneNumber: string;
    phoneText: string;
    clientKeys: clientKeys[];
    placardInformation: ConfirmedPlacardInformation;
    nndays: number;
    errors: Error[];
    deactivationDate: string;
    reactivationDate: string;
    activationDate: string;
    multiClientKeyIndicator: string;
    hasPendingChanges: boolean;
}


